<img [src]="plagFreeImg | safe : 'url'" alt="Matches free" />
<label *ngIf="!isHighNotificationSeverity">
	<ng-container *ngIf="(results$ | async).length">
		{{ translations?.PLAGIARISM_FREE_WITH_RESULTS || 'No Matches Found With Applied Filters' }}
	</ng-container>
	<ng-container *ngIf="!(results$ | async).length">
		{{ translations?.PLAGIARISM_FREE || 'No Matches Found' }}
	</ng-container>
</label>
<label *ngIf="isHighNotificationSeverity">
	{{ translations?.PLAGIARISM_FREE_WITH_NOTIFICATIONS || 'Cheating Detected' }}
</label>

<div class="notification-section">
	<cr-notifications (severityChange)="onNotificationSeverityChange($event)"></cr-notifications>
</div>
